import Vue from 'vue'
import parse from 'date-fns/parse'
import {
  // eslint-disable-next-line camelcase
  alpha_spaces,
  between,
  required,
  email,
  digits,
  min,
  max,
  numeric,
  length,
  confirmed,
} from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'

// To add more rules follow this guide:
// https://vee-validate.logaretm.com/v3/guide/basics.html#adding-rules
extend('alpha_spaces', alpha_spaces)
extend('between', between)
extend('email', email)
extend('digits', digits)
extend('min', min)
extend('max', max)
extend('length', length)
extend('numeric', numeric)
extend('confirmed', confirmed)

const _required = { ...required }
_required.validate = (value, { allowFalse }) => {
  if (value && typeof value === 'object' && 'value' in value) {
    value = value.value
  }

  return required.validate(value, { allowFalse })
}

extend('required', _required)

const isMinimumAge = (newDob) => {
  // helper function to validate date chosen >= 18y/o
  const dob = new Date(newDob.toString())
  const year = dob.getFullYear()
  const month = dob.getMonth()
  const day = dob.getDate()
  const minDob = new Date(year + 18, month, day)
  const today = new Date()
  const result = minDob <= today
  return result
}

const isMaximumAge = (newDob) => {
  // helper function to validate date chosen >= 18y/o
  const dob = new Date(newDob.toString())
  const year = dob.getFullYear()
  const month = dob.getMonth()
  const day = dob.getDate()
  const maxDob = new Date(year + 110, month, day)
  const today = new Date()
  const result = maxDob >= today && dob <= today
  return result
}

extend('minimum_age', {
  validate: (value) => {
    try {
      return isMinimumAge(value)
    } catch (error) {
      return false
    }
  },
})

extend('maximum_age', {
  validate: (value) => {
    try {
      return isMaximumAge(value)
    } catch (error) {
      return false
    }
  },
})

extend('validate_date', {
  validate: (value) => {
    const dateParsed = parse(value, 'MM/dd/yyyy', new Date())
    if (String(dateParsed) === 'Invalid Date') return false
    const year = dateParsed.getFullYear()
    return year > 1900
  },
})

// extend('bod_daterange', {
//   validate: (value) => {
//     const today = new Date()
//     const year = today.getFullYear()
//     const month = today.getMonth()
//     const day = today.getDate()
//     const oldestAllowedDate = new Date(year - 110, month, day)
//     return oldestAllowedDate <= value && value <= today
//   },
// })

extend('alpha_common_puntuation_marks', {
  validate: (value) => {
    return /^[0-9A-Z\s!?',._-]*$/i.test(value)
  },
})

extend('alpha_spaces_strict', {
  validate: (value) => {
    return /^[A-Z\s]*$/i.test(value)
  },
})

// register component
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
